import { RunMode } from '~~/interface/Pos';

import { FIRESTORE_COLLECTIONS } from "~~/interface/FirestoreCollections";
import { child, set, } from 'firebase/database';
import {  updateDoc, setDoc } from "firebase/firestore";
import { PiniaPluginContext } from 'pinia'
import _ from 'lodash';
import { buildLiveSummary, isLiveSyncSuspended } from '../composables/useTableSync';
import { syncAllToCloud } from '../composables/useCloudSync';
import {
  markLiveSyncAttempt,
  markLiveSyncOk,
  reportLiveSyncError,
  trackSyncWrite,
} from '~~/modules/core/utils/liveSyncStatus';

function MobileItemsPlugin({ store }: PiniaPluginContext) {

  if (store.$id == 'jobs') {
    const firestoreDb = useFirebaseFirestore();
    let previousTablesStata = null
    // trigger แรกหลัง boot ส่งทั้งก้อน (เดิมข้ามรอบนี้ไปเลย cloud ค้างค่าเก่าจนกว่าจะมีคนแก้โต๊ะ)
    let firstPublish = true
    let syncToFirebaseLazy = _.debounce(syncToFirebase, 1500)

    // subscribe ทุกโหมด แล้วไปเช็คโหมดตอน sync แทน
    // เดิมอ่าน getMode() ครั้งเดียวตอน jobs store ถูกสร้าง ถ้าจังหวะนั้นยังไม่ได้ค่า
    // main_cashier เครื่องจะไม่ sync live เลยทั้ง session ทั้งที่ header และ
    // watchHandshake (อ่านโหมดทีหลัง) เห็นเป็น main และรับงานจาก terminal ได้ปกติ
    store.$subscribe((mutation, state) => {

      if (previousTablesStata != state.tables) {
        previousTablesStata = state.tables
        syncToFirebaseLazy()

      }

    })

    function syncToFirebase() {


      if (useRunningMode().getMode() !== RunMode.MAIN_CASHIER) return
      // ช่วงหลังปิดร้านก่อนหน้า reload: ห้ามเขียนยอดของรอบที่ปิดแล้วทับ live = 0
      // (เหตุผล + ตัวอย่างดู liveSyncSuspended ใน useTableSync.ts)
      if (isLiveSyncSuspended()) return

      markLiveSyncAttempt()

      // ไม่ต้องรอว่า jobchain โหลดครบหรือยัง — ถ้ายังไม่ครบ job ที่ตามมาจะ trigger รอบถัดไปเขียนทับเอง
      if (firstPublish) {
        firstPublish = false
        trackSyncWrite("initialSync", () => syncAllToCloud(), markLiveSyncOk)
        return
      }
      const tables = previousTablesStata

      // แต่ละขั้นแยก error กัน — ของเดิม RTDB set(tables) เจอ NaN แล้ว throw
      // ขั้นที่เหลือรวมถึง Firestore ที่มือถืออ่านก็ไม่ถูกเรียกไปด้วย
      trackSyncWrite("tables", () => set(useFirebase().tablesRef(), tables))

      let summary
      try {
        summary = buildLiveSummary(store as any)
      } catch (error) {
        reportLiveSyncError("summary", error)
        return
      }

      trackSyncWrite("live", () => set(useFirebase()._createRef("live"), summary))
      trackSyncWrite("liveFirestore", () => updateLiveToFirestore(summary), markLiveSyncOk)
    }


    function updateLiveToFirestore(liveData){
      let liveRef = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.SYNC_DATA,FIRESTORE_COLLECTIONS.LIVE)
      return setDoc(liveRef, liveData,{merge: true});
    }
  }

}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(MobileItemsPlugin)
})
